import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VizsgazoEditDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {number} */
		this.pontszam = null;
		/** @type {number} */
		this.erdemjegy = null;
		/** @type {string} */
		this.azonosito = null;
		/** @type {string} */
		this.vezeteknev = null;
		/** @type {string} */
		this.keresztnev = null;
		/** @type {number} */
		this.vizsgaHelyeVizsgazo = null;
		/** @type {number} */
		this.vizsgaVizsgazo = null;
		/** @type {string} */
		this.jelszo = null;
		/** @type {Date} */
		this.bornDate = null;
		/** @type {string} */
		this.mothersName = null;
	}

	/**
	 * @typedef {Object} _VizsgazoEditDtoProps
	 * @property {number} pontszam
	 * @property {number} erdemjegy
	 * @property {string} azonosito
	 * @property {string} vezeteknev
	 * @property {string} keresztnev
	 * @property {number} vizsgaHelyeVizsgazo
	 * @property {number} vizsgaVizsgazo
	 * @property {string} jelszo
	 * @property {Date} bornDate
	 * @property {string} mothersName
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _VizsgazoEditDtoProps} VizsgazoEditDtoProps
	 */
	/**
	 *
	 * @param {VizsgazoEditDtoProps} props
	 * @returns {VizsgazoEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.pontszam = props.pontszam;
		this.erdemjegy = props.erdemjegy;
		this.azonosito = props.azonosito;
		this.vezeteknev = props.vezeteknev;
		this.keresztnev = props.keresztnev;
		this.vizsgaHelyeVizsgazo = props.vizsgaHelyeVizsgazo;
		this.vizsgaVizsgazo = props.vizsgaVizsgazo;
		this.jelszo = props.jelszo;
		this.bornDate = props.bornDate !== null ? new Date(props.bornDate) : null;
		this.mothersName = props.mothersName;
		return this;
	}
}

export default VizsgazoEditDto;
